import { ProjectAction } from "../types/projectDataSettings"
import { Dispatch } from "react"
import { ProjectActionType } from "../types/projectDataSettings"
import projectApi from "../../api/projectDataApi"

function getProject(projectId: string | null) {
  if (!projectId) {
    return
  }

  return async (dispatch: Dispatch<ProjectAction>) => {
    try {
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_SETTINGS })
      const response = await projectApi.getProjectData(projectId)
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_SETTINGS_SUCCESS, payload: response })
    } catch (error) {
      dispatch({
        type: ProjectActionType.FETCH_PROJECT_DATA_SETTINGS_ERROR,
        payload: "Error loading projects",
      })
    }
  }
}

export default {
  getProject,
}
